import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { TextLine } from "@ltypes/scene";
import TextField from "@components/forms/TextField/TextField";
import Slider from "@components/forms/Slider/Slider";
import Color from "@components/forms/Color/Color";
import "./SceneTextLine.scss";
import Button from "@components/forms/Button/Button";
import Select from "@components/forms/Select/Select";
import Product, { ProductModelType } from "@ltypes/product";

type SceneTextLineProps = {
    index: number,
    line: TextLine|null,
    onChange: (line: TextLine) => void,
    onDelete: () => void,
};

function SceneTextLine(props: SceneTextLineProps) {

    const { t } = useTranslation();
    const product: Product = useSelector((state: any) => state.product);

    const handleChangeText = (field: string, value: string) => {
        if(value === '' || /^[\x20-\x7E]+$/.test(value)) {
            handleChange(field, value);
        }
    };

    const handleChange = (field: string, value: string|number): void => {
        if(!props.line) {
            return;
        }

        props.onChange({
            ...props.line,
            [field]: value,
        });
    };

    return (
        <div className="scenetext-line">
            <div className="row g-3">
                <div className="col-auto">
                    <span className="scenetext-line-title">{t('page.scenes.data.line_index', { index: props.index })}</span>
                </div>
                <div className="col text-right">
                    <Button size="sm" className="secondary" onClick={props.onDelete}>{t('text.delete')}</Button>
                </div>
            </div>
            {props.line !== null && (
                <div className="row mt-0 g-3">
                    <div className="col-12 col-md-3">
                        <TextField label={t('page.scenes.data.your_text')} value={props.line.text} placeholder={t('page.scenes.data.your_text_placeholder')} onChange={(value: string) => handleChangeText('text', value)}/>
                    </div>
                    <div className="col-6 col-md-2">
                        <Color label={t('page.scenes.data.text_color')} value={props.line.textcolor} onChange={(value: string) => handleChange('textcolor', value)}/>
                    </div>
                    <div className="col-6 col-md-3 align-self-center">
                        <Select label={t('page.scenes.data.text_size')} value={props.line.textsize} items={product.model.type === ProductModelType.LEGACY ? [{ label: '0', value: 0 }, { label: '1', value: 1 }, ] : new Array(7).fill(0).map((_, index: number) => ({
                            label: `${index+1}`,
                            value: index+1,
                        }))} onChange={(value: string) => handleChange('textsize', Number(value))}></Select>
                    </div>
                    <div className="col-12 col-sm-6 col-md-2">
                        <Slider label={t('page.scenes.data.speed')} value={props.line.speed} onChange={(value: number) => handleChange('speed', value)}/>
                    </div>
                    <div className="col-12 col-sm-6 col-md-2">
                        <Select label={t('page.scenes.data.text_position')} value={props.line.textalignment} items={props.line.speed > 0 ? [{ label: t('page.scenes.moving'), value: 0 }] : [
                            { label: t('text.left'), value: '0' },
                            { label: t('text.center'), value: '1' },
                            { label: t('text.right'), value: '2' },
                        ]} onChange={(value: string) => handleChange('textalignment', Number(value))} disabled={props.line.speed > 0}></Select>
                    </div>
                </div>
            )}
        </div>
    );
}

export default SceneTextLine;
